import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { DownloadService } from '../../services/download.service';

// Global download indicator — a single floating chip (bottom-right) shown while any download runs,
// regardless of which page started it. Reads the shared DownloadService state. Lives in the app
// shell so a download keeps showing after navigating away.
@Component({
  selector: 'app-download-indicator',
  standalone: true,
  imports: [MatIconModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (download.isDownloading()) {
    <div class="fixed bottom-4 right-4 z-[1000] flex items-center gap-3 rounded-sxl bg-white border border-grey-200 shadow-lg px-4 py-3 max-w-xs">
      <mat-icon class="text-xl w-5 h-5 leading-none text-primary-500 animate-spin shrink-0">progress_activity</mat-icon>
      <div class="min-w-0">
        <div class="text-s font-semibold text-grey-800 truncate">{{ download.downloadingName() }}</div>
        <div class="text-2xs text-grey-500">
          {{ download.progress() != null ? download.progress() + '%' : ('DOWNLOAD.DOWNLOADING' | translate) }}
        </div>
      </div>
    </div>
    }
  `,
})
export class DownloadIndicatorComponent {
  readonly download = inject(DownloadService);
}
